export const commonPt = {
  loading: 'Carregando',
  edit: 'Editar',
  remove: 'Remover',

  exceptions: {
    applicationException: 'Ocorreu um erro inesperado',
    forbiddenException: (resource: string): string =>
      `Sem permissão para acessar o recurso: ${resource}`,
    notFound: 'Registro não encontrado',
    unauthorizedException: 'Credenciais inválidas ou sessão expirada',
    unprocessableEntityException: 'Ocorreu uma falha na regra de negócio',
    validationException: 'Ocorreu um erro de validação'
  },
  components: {
    drawer: {
      options: {
        users: 'Usuários',
        logout: 'Sair'
      }
    }
  },
  layouts: {
    baseBackground: {
      footer: {
        copyright: '© Positivo Tecnologia S.A. Todos os direitos reservados.',
        terms: 'Termos de Uso',
        privacy: 'Privacidade'
      }
    }
  },
  pages: {
    notFound: {
      title: 'Página não encontrada',
      message: 'Página não encontrada',
      verifyTypedAddress: 'Verifique o endereço digitado e tente novamente.',
      buttons: {
        goBack: 'Voltar ao início'
      }
    }
  },
  services: {
    api: {
      makeRefreshToken: 'Atualizar token da sessão'
    }
  },
  validators: {
    oneOf: (values: number[] | string[] | readonly number[] | readonly string[]): string =>
      `Selecione algum dos valores: ${values.join(', ')}`,
    max: (value: number): string => `Este campo deve conter no máximo ${value} de tamanho`,
    min: (value: number): string => `Este campo deve conter no mínimo ${value} de tamanho`,
    maxValue: (value: number | string): string =>
      `Este valor deve ser menor ou igual a(o) ${value}`,
    minValue: (value: number | string): string =>
      `Este valor deve ser maior ou igual a(o) ${value}`,
    required: 'Este campo é obrigatório',
    url: 'Este campo deve ser uma URL válida',
    isDateSmallerToNow: 'É necessário inserir uma data válida.',
    cpfInvalid: 'CPF inválido',
    phoneInvalid: 'É necessário inserir um telefone válido.',
    emailInvalid: 'E-mail inválido',
    emailNotFound: 'Endereço de e-mail não encontrado',
    codeInvalid: 'Código inválido',
    minPasswordInvalid: 'A senha deve ter no mínimo 6 caracteres, podendo conter números e letras.',
    notEqualsPasswordInvalid: 'As senhas não combinam',
    validateDateRange: 'É necessário inserir uma data posterior a data de início.',
    validateLaterDate: 'É necessário inserir uma data anterior à data atual',
    withoutSpace: 'Este campo não deve conter espaços',
    trimString: 'Este campo não deve espaço no inicio e fim ou espaços duplos',
    lowercase: 'Este campo deve conter no mínimo uma letra minúscula',
    number: 'Este campo deve conter no mínimo um número',
    uppercase: 'Este campo deve conter no mínimo uma letra maiúscula',
    specialCharacter: 'Este campo deve conter no mínimo um caractere especial',
    unique: 'Este valor já está sendo utilizado',
    email: 'Este campo deve ser um e-mail válido',
    document: 'Este campo deve ser um CPF ou CNPJ válido',
    sameOf: 'Esta senha deve ser a mesma digitada no campo anterior'
  }
}
